import { v2gate, gate } from 'hub-http/gates';
export const HELP_DESK_ROUTING_SCOPE_FILTERING = v2gate('HelpDeskRoutingScopeFiltering');
export const USER_AWARE_ROUTING_RULES = gate('RoutingRules:UserAware');
export const USER_LEVEL_CAPACITY_LIMITS = gate('Routing:UserLevelCapacityLimits');
export const USER_LEVEL_CAPACITY_LIMITS_TICKET_TYPE = gate('Routing:UserLevelCapacityLimits:TicketType');
export const ROUTING_WORKSPACE_RESPONDER_CHIRP = gate('Routing:WorkspaceResponderChirp');
export const CAPACITY_CALL_STATUS = gate('Routing:UserLevelCapacityLimits:CallStatus');